import { render, staticRenderFns } from "./sub-num-item.vue?vue&type=template&id=1fba2768&scoped=true"
import script from "./sub-num-item.vue?vue&type=script&lang=js"
export * from "./sub-num-item.vue?vue&type=script&lang=js"
import style0 from "./sub-num-item.vue?vue&type=style&index=0&id=1fba2768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fba2768",
  null
  
)

export default component.exports